import { render, staticRenderFns } from "./CxMessageToast.vue?vue&type=template&id=6bf602fb&scoped=true"
import script from "./CxMessageToast.vue?vue&type=script&lang=js"
export * from "./CxMessageToast.vue?vue&type=script&lang=js"
import style0 from "./CxMessageToast.vue?vue&type=style&index=0&id=6bf602fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf602fb",
  null
  
)

export default component.exports